import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

import SecureLS from "secure-ls";
var ls = new SecureLS({ isCompression: false });

export default createStore({
  state: {
    user: null,
    saltKey: import.meta.env.VUE_APP_SALT_KEY,
    schema: [], 
 exam: [], 
 simulation: [], 
 subjects: [], 
 students: [], 
 schools: [], 
 ders: [], 
 sinif: [], 
 options: [], 
 units: [], 
 slider: [], 
    files: [], 
    sinif: [],
    ders: [],
    kazanim: [],
    kaynak: [],
    users: [],
    contacts: [],
    tasks: [],
    mermaid: []
  },
  mutations: {
    setUser(state, user) {
      console.log("user :>> ", user);
      state.user = user;
    },
    logoutUser(state) {
      state.user = null;
    },
    addContacts(state, contacts) { 
      state.contacts = [...contacts]; 
    }, 
    addFiles(state, files) { 
 state.files = [...files]; 
},  
    addSinif(state, sinif) { 
 state.sinif = [...sinif]; 
}, 
    addDers(state, ders) { 
 state.ders = [...ders]; 
}, 
    addKazanim(state, kazanim) { 
 state.kazanim = [...kazanim]; 
}, 
    addKaynak(state, kaynak) { 
 state.kaynak = [...kaynak]; 
}, 
 addSlider(state, slider) { 
 state.slider = [...slider]; 
}, 
 addUnits(state, units) { 
 state.units = [...units]; 
}, 
 addOptions(state, options) { 
 state.options = [...options]; 
}, 
 addSinif(state, sinif) { 
 state.sinif = [...sinif]; 
}, 
 addDers(state, ders) { 
 state.ders = [...ders]; 
}, 
 addSchools(state, schools) { 
 state.schools = [...schools]; 
}, 
 addStudents(state, students) { 
 state.students = [...students]; 
}, 
 addSubjects(state, subjects) { 
 state.subjects = [...subjects]; 
}, 
 addSimulation(state, simulation) { 
 state.simulation = [...simulation]; 
}, 
 addExam(state, exam) { 
 state.exam = [...exam]; 
}, 
 addSchema(state, schema) {
      state.schema = [...schema];
    },
    addUsers(state, users) {
      state.users = [...users];
    },
    addTasks(state, tasks) {
      state.tasks = [...tasks];
    },
    addMermaid(state, mermaid) {
      state.mermaid = [...mermaid];
    },
    addMermaidItem(state, item) {
      state.mermaid.push(item);
    },
    updateMermaidItem(state, updatedItem) {
      const index = state.mermaid.findIndex(item => item.id === updatedItem.id);
      if (index !== -1) {
        state.mermaid.splice(index, 1, updatedItem);
      }
    },
    deleteMermaidItem(state, id) {
      state.mermaid = state.mermaid.filter(item => item.id !== id);
    }
  },
  getters: {
    _isAuthenticated: (state) => state.user !== null,
    _getCurrentUser(state) {
      const user = state.user;

      delete user?.password;
      return user;
    },
    _currentUserId: (state) => state?.user?.id,
    _getCurrentRole: (state) => parseInt(state?.user?.role),
    _saltKey: (state) => state.saltKey,
    _getContacts: (state) => state?.contacts, 
    _getFiles: (state) => state?.files, 
    _getKaynak: (state) => state?.kaynak,
 _getSlider: (state) => state?.slider, 
 _getUnits: (state) => state?.units, 
 _getOptions: (state) => state?.options, 
 _getSinif: (state) => state?.sinif, 
 _getDers: (state) => state?.ders, 
 _getSchools: (state) => state?.schools, 
 _getStudents: (state) => state?.students, 
 _getSubjects: (state) => state?.subjects, 
 _getSimulation: (state) => state?.simulation, 
 _getExam: (state) => state?.exam, 
 _getSchema: (state) => state?.schema,
    _getSinif: (state) => state?.sinif,
    _getDers: (state) => state?.ders,
    _getKazanim: (state) => state?.kazanim,
    _getUsers: (state) => state?.users,
    _getTasks: (state) => state?.tasks,
    _getMermaid: (state) => state?.mermaid,
  },
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
});
